import { useQuery } from "urql";
import { graphql } from "../../__generated__/gql";
import Select from "../../ui/Select/Select";
import { forwardRef } from "react";
import Loader from "../../ui/Loader/Loader";
import { InputWrapperProps } from "../../ui/InputWrapper/InputWrapper";
import { Link } from "react-router-dom";
import urls from "../../routes";

const TagSelectQuery = graphql(/* GraphQL */ `
  query tagSelect {
    tags {
      id
      name
    }
  }
`);

type TagSelectProps = {
  className?: string;
  size?: InputWrapperProps["size"];
  value?: string;
  onChange: (value?: string | null) => void;
  onBlur: () => void;
  disabled?: boolean;
  loading?: boolean;
  loadingMessage?: string;
};

const TagSelect = forwardRef<HTMLDivElement, TagSelectProps>(function TagSelect(
  {
    value,
    onChange,
    onBlur,
    size,
    className,
    disabled,
    loading,
    loadingMessage,
  },
  ref,
) {
  const [tagSelectResponse] = useQuery({
    query: TagSelectQuery,
    requestPolicy: "cache-and-network",
  });

  const tags =
    tagSelectResponse.data?.tags
      ?.filter((tag): tag is typeof tag & { name: string } => !!tag.name)
      .map((tag) => ({
        label: tag.name,
        value: tag.id,
      })) ?? [];

  if (tagSelectResponse.fetching) {
    return <Loader />;
  }

  return (
    <Select
      className={className}
      size={size}
      clearable
      placeholder={
        tags.length > 0 ? (
          "Select an option"
        ) : disabled ? (
          "No tags available."
        ) : (
          <>
            No tags available.{" "}
            <Link to={urls.settings.generation.tags}>Add tags</Link>
          </>
        )
      }
      disabled={tags.length === 0 || disabled}
      data={tags}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      ref={ref}
      loading={loading}
      loadingMessage={loadingMessage}
      withinPortal
    />
  );
});

export default TagSelect;
